import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const FurnitureIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 1 34 34"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5197 0.720215C32.6443 0.720215 34.3199 2.43858 34.3199 4.52182V24.8258C34.3199 26.4594 33.3039 27.8286 31.8878 28.374L31.8912 28.4218V33.0845C31.8912 34.1957 31.1176 35.0329 30.0439 35.1276L29.8392 35.1365H28.9651C27.8981 35.1365 27.0844 34.4259 26.937 33.4178L26.9165 33.2124L25.9638 28.6422L25.9609 28.6277L9.32866 28.6274L9.32738 28.6422L8.37466 33.2124C8.31788 34.258 7.56631 35.0342 6.53581 35.1271L6.32611 35.1365H5.45203C4.34263 35.1365 3.50383 34.3646 3.40898 33.2895L3.40003 33.0845V28.4218C3.40003 28.3921 3.40123 28.3626 3.40359 28.3335C2.02336 27.7616 1.06882 26.3975 1.06882 24.8258V4.61829C1.06882 2.48762 2.79444 0.720215 4.87042 0.720215H30.5197ZM7.12258 28.6274H5.55874L5.56003 32.9765H6.22925L6.24084 32.8641L7.12258 28.6274ZM28.1667 28.6274H29.7306L29.7312 32.9765H29.0619L29.0503 32.8641L28.1667 28.6274ZM32.1599 15.8402H3.22882V24.8258C3.22882 25.7277 3.95064 26.4674 4.87042 26.4674H30.5197C31.4203 26.4674 32.1599 25.7455 32.1599 24.8258V15.8402ZM23.6325 19.0942C23.6325 18.4977 23.1489 18.0142 22.5525 18.0142H12.9333C12.3368 18.0142 11.8533 18.4977 11.8533 19.0942C11.8533 19.6907 12.3368 20.1742 12.9333 20.1742H22.5525C23.1489 20.1742 23.6325 19.6907 23.6325 19.0942ZM30.5197 2.88021H4.87042C3.9991 2.88021 3.22882 3.66915 3.22882 4.6183V13.6802H32.1599V4.52182C32.1599 3.61948 31.439 2.88021 30.5197 2.88021ZM23.6325 6.26911C23.6325 5.67264 23.1489 5.18911 22.5525 5.18911H12.9333C12.3368 5.18911 11.8533 5.67264 11.8533 6.26911C11.8533 6.86558 12.3368 7.34911 12.9333 7.34911H22.5525C23.1489 7.34911 23.6325 6.86558 23.6325 6.26911Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default FurnitureIcon;
